import loadingSpinner from './components/loading-spinner'
import { NistBulkOnboarding, BULK_STATE } from '../../util/nist-bulk-onboarding'

// NIST batch setup, screen 2: the run itself, one row per sensor, then the
// tally. The work is in util/nist-bulk-onboarding.js; this just draws it.
export class StepBulkRun {
  constructor (onboarding) {
    this.onboarding = onboarding;
  }

  id = "bulk_run";
  title = "Setting Up Sensors";

  template = `
  <div class="onboarding-step" data-for="bulk_run">

    <div class="onboarding-bulk-progress">
      <div class="onboarding-bulk-progress__bar"><div class="onboarding-bulk-progress__fill"></div></div>
      <div class="onboarding-bulk-progress__text"></div>
    </div>

    <div class="onboarding-bulk-list"></div>

    <p class="onboarding-guide-instruction-smaller medium-text-center" data-for="bulk_run_note">
      Keep the app open and stay near the sensors. Each one is named after its ID once it's on the account.
    </p>

    <div class="onboarding-bulk-actions" style="display: none;">
      <button type="button" class="button button--medium" data-for="bulk_retry" style="display: none;"></button>
      <button type="button" class="button button--medium" data-for="bulk_more">Set Up More</button>
      <button type="button" class="button button--blue-outline" data-for="bulk_done">Done</button>
    </div>

  </div>
  `;

  onBack = () => {
    // nothing to go back to mid-run; the buttons at the end lead out
  }

  onActivate = () => {

    this.onboarding.hideBackButton();

    if (!this.onboarding.bulk || this.onboarding.bulk.wifi !== this.onboarding.bulk_wifi) {
      this.onboarding.bulk = new NistBulkOnboarding(this.onboarding, this.onboarding.bulk_devices, this.onboarding.bulk_wifi);
    }

    const bulk = this.onboarding.bulk;

    bulk.onChange = (items, summary) => this.render(items, summary);
    this.render(bulk.items, bulk.summary());

    if (!bulk.running) {
      bulk.run();
    }

  }

  bindActions = () => {

    const $step = $(this.onboarding.container).find('.onboarding-step[data-for="bulk_run"]');

    this.$fill = $step.find('.onboarding-bulk-progress__fill');
    this.$progressText = $step.find('.onboarding-bulk-progress__text');
    this.$list = $step.find('.onboarding-bulk-list');
    this.$note = $step.find('[data-for="bulk_run_note"]');
    this.$actions = $step.find('.onboarding-bulk-actions');
    this.$retryBtn = $step.find('button[data-for="bulk_retry"]');
    this.$moreBtn = $step.find('button[data-for="bulk_more"]');
    this.$doneBtn = $step.find('button[data-for="bulk_done"]');

    this.$retryBtn.on('click', () => {
      if (this.onboarding.bulk && !this.onboarding.bulk.running) {
        this.onboarding.bulk.retryFailed();
      }
    });

    this.$moreBtn.on('click', () => {
      const sv = this.onboarding.sensor_version || 'v2';
      window.location.href = window.site.home + '/setup?quick_add=1&sensor_version=' + encodeURIComponent(sv);
    });

    this.$doneBtn.on('click', () => {
      window.location.href = window.site.home + '/sensors';
    });

  }

  render(items, summary) {

    const finishedCount = summary.done + summary.failed;
    const pct = summary.total > 0 ? Math.round((finishedCount / summary.total) * 100) : 0;

    this.$fill.css('width', `${pct}%`);

    if (summary.finished) {
      this.$progressText.html(summary.failed === 0
        ? `<b>All ${summary.total} sensor${summary.total === 1 ? '' : 's'} set up.</b>`
        : `<b>${summary.done} of ${summary.total} set up</b> &middot; ${summary.failed} failed`);
    } else {
      this.$progressText.html(`${finishedCount} of ${summary.total} finished`);
    }

    this.$list.html(items.map(item => {

      const label = item.sensorId ? item.sensorId : (item.name || item.address);
      let icon = '';
      let cls = '';

      switch (item.state) {
        case BULK_STATE.DONE:
          cls = 'is-done';
          icon = '<span class="onboarding-bulk-list__icon onboarding-bulk-list__icon--done">&#10003;</span>';
          break;
        case BULK_STATE.FAILED:
          cls = 'is-failed';
          icon = '<span class="onboarding-bulk-list__icon onboarding-bulk-list__icon--failed">&#10005;</span>';
          break;
        case BULK_STATE.QUEUED:
          cls = 'is-queued';
          icon = '<span class="onboarding-bulk-list__icon onboarding-bulk-list__icon--queued"></span>';
          break;
        case BULK_STATE.TESTING:
          cls = 'is-testing';
          icon = '<span class="onboarding-bulk-list__icon onboarding-bulk-list__icon--testing"></span>';
          break;
        default:
          cls = 'is-busy';
          icon = `<span class="onboarding-bulk-list__icon onboarding-bulk-list__icon--busy">${loadingSpinner()}</span>`;
          break;
      }

      const message = item.state === BULK_STATE.QUEUED ? 'Waiting' : (item.message || '');

      return `
        <div class="onboarding-bulk-list__row ${cls}">
          ${icon}
          <div class="onboarding-bulk-list__body">
            <div class="onboarding-bulk-list__sid">${label}</div>
            <div class="onboarding-bulk-list__message">${message}</div>
          </div>
        </div>
      `;

    }).join(''));

    this.$note.toggle(!summary.finished);
    this.$actions.toggle(summary.finished);

    if (summary.finished) {
      this.$retryBtn.toggle(summary.failed > 0).text(`Retry ${summary.failed} failed`);
      this.onboarding.showBackButton();
    }

  }

}
